import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Beneficiaire } from 'src/app/shared/models/beneficiaire';
import { Vehicle } from 'src/app/shared/models/vehicle';
import { VehiculeStatus } from 'src/app/shared/enums/vehicule-status-enum';
import { ConstantsService } from '../constant/constants.service';
import { GenericCrudService } from '../generic-crud.service';

@Injectable({
	providedIn: 'root'
})
export class VehiculeService {
	constructor(
		private appConstants: ConstantsService,
		private genericCrudService: GenericCrudService
	) {}

	getAllVehicule(): Observable<any> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.vehiculeUrl}s`,
			'getAllVehicule'
		);
	}

	getAllVehiculesByStatus(status: VehiculeStatus): Observable<any> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.vehiculeUrl}s/${status}`,
			'getAllVehiculesByStatus'
		);
	}

	getVehiculeById(vehiculeId: number) {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.vehiculeUrl}/${vehiculeId}`,
			'getVehiculeById'
		);
	}

	addVehicule(vehicule: Vehicle): Observable<Beneficiaire> {
		return this.genericCrudService.genericPostDataToAPI(
			`${this.appConstants.vehiculeUrl}`,
			`addVehicule`,
			vehicule
		);
	}

	updateVehicule(vehicule: Vehicle): Observable<Vehicle> {
		return this.genericCrudService.genericPostDataToAPI(
			`${this.appConstants.vehiculeUrl}`,
			`updateVehicule`,
			vehicule
		);
	}

	deleteVehicule(vehicule: Vehicle): Observable<void> {
		return this.genericCrudService.genericDeleteAPIDataByID(
			`${this.appConstants.vehiculeUrl}/${vehicule.id}`,
			`deleteVehicule`
		);
	}
}
